<template>
  <a-descriptions :column='1'>
    <a-descriptions-item label="入库单号">{{orderData.warehousing_sn}}</a-descriptions-item>
    <a-descriptions-item label="生产批次">{{orderData.product_batch_name || '-'}}<a-button @click="batchVisble=true" v-if="orderData.product_batch_name" class="m-l-10">修改</a-button></a-descriptions-item>
    <a-descriptions-item label="商品名称">{{orderData.product_sku_name || '单规格'}} - {{orderData.product_name}}</a-descriptions-item>
    <a-descriptions-item label="商品规格">{{orderData.product_sku_sn || '-'}}</a-descriptions-item>
    <a-descriptions-item label="入库数量">{{orderData.code_num}}</a-descriptions-item>
    <a-descriptions-item label="入库仓库">{{orderData.warehouse_name}}</a-descriptions-item>
    <a-descriptions-item label="库位">{{orderData.position_name || '-'}}</a-descriptions-item>
    <a-descriptions-item label="创建时间">{{orderData.created_at}}</a-descriptions-item>
  </a-descriptions>
       <a-modal :keyboard="false" title="修改批次"  v-model:visible="batchVisble" centered :footer="null" :width='1300' destroyOnClose>
    <selectGoodBatch v-on:select="batchSelect" :productSkuSn="orderData.product_sku_sn" :productId="orderData.product_id" :checkout="false"></selectGoodBatch>
   </a-modal>
</template>
<script>
  import { reactive, ref, toRefs, onMounted, inject } from "vue";
  import { message ,Modal} from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import { getWarehousingMore,changeWarehousingBatch} from '@/api/antiFleeing';
  export default {
    components: {},
    props: {
      id: {
        type: String||Number
      },
      type:{
        type: String
      }
    },
    setup(props) {
      const state = reactive({
        orderData:{},
      });
      const $route = inject("$route");
      //获取详情
      const getMore = async () => {
        const hide = message.loading("正在加载中...", 0);
        let res = await getWarehousingMore(props.id ).then((res) => res.data).catch(error => error);
        if (iscode(res)) {
          state.orderData = res.data;
        } else {
          message.error(res.msg);
        }
        setTimeout(hide);
      };
      onMounted(() => {
        getMore();
      });
      
      const batchHandle=()=>{
        const batchVisble=ref(false)
        const batchSelect=(data)=>{
          editBatchSelect(data)
        }
        var editBatchSelect = async (data) => {
            const json={
              type:1,
              sn:[state.orderData.warehousing_sn],
              batch_id:state.orderData.product_batch_id,
              new_batch_id:data.id,
                    product_id:data.product_id,
        product_sku_sn:data.product_sku_sn
            }
            let result=await changeWarehousingBatch(json).then(res=>res.data).catch(error=>error)
            if(iscode(result,true)){
                 getMore();
                 batchVisble.value=false
            }
          };
        return{
            batchVisble,
            batchSelect
        }
      }
      return {
        ...toRefs(state),
        ...batchHandle()
      };
    },
  };
</script>